module.exports = __webpack_public_path__ + "img/61.760323ee.png";